import React, { useState } from 'react';
import { Form, Button, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS if not already included
import { Link } from 'react-router-dom';


// Define inline styles
const containerStyle = {
  maxWidth: '600px',
marginTop:'15px',
  padding: '20px',
  border: '1px solid #ced4da',
  borderRadius: '0.25rem',
  boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
  backgroundColor: '#ffffff',
};



const formLabelStyle = {
  fontSize: '1rem',
  fontWeight: '500',
  color: '#495057',
};

const requiredStyle = {
  color: '#dc3545',
};

const selectStyle = {
  borderColor: '#ced4da',
  borderRadius: '0.25rem',
};


const AlloySalesReport = () => {
    const [startDate, setStartDate] = useState("2024-09-01");
    const [endDate, setEndDate] = useState("2024-09-30");
    const [format, setFormat] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle the form submission logic here
    };

    return (
    <>        <h2 className="text-left mb-4 text-dark">Parameters</h2>
        <div style={containerStyle}>
   
            <Form onSubmit={handleSubmit} className="report_parameters no_print medium_label" id="report_alloy_sales">
                <fieldset>
                 

                    <Form.Group as={Row} controlId="alloy-sales-start-date">
                        <Form.Label column sm={2} style={formLabelStyle}>
                            Start Date <span style={requiredStyle}>*</span>
                        </Form.Label>
                        <Col sm={10}>
                            <Form.Control
                                type="date"
                                name="start_date"
                                required
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                                style={selectStyle}
                            />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="alloy-sales-end-date">
                        <Form.Label column sm={2} style={formLabelStyle}>
                            End Date <span style={requiredStyle}>*</span>
                        </Form.Label>
                        <Col sm={10}>
                            <Form.Control
                                type="date"
                                name="end_date"
                                required
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                                style={selectStyle}
                            />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="report_alloy_sales_format">
                        <Form.Label column sm={2} style={formLabelStyle}>
                            Format <span style={requiredStyle}>*</span>
                        </Form.Label>
                        <Col sm={10}>
                            <Form.Control
                                as="select"
                                name="format"
                                value={format}
                                onChange={(e) => setFormat(e.target.value)}
                                style={selectStyle}
                            >
                                <option value="">On Screen</option>
                                <option value="csv">CSV (Excel)</option>
                            </Form.Control>
                        </Col>
                    </Form.Group>

                    
                            <Form.Group as={Row}>
                                    <Col sm={{ span: 8, offset: 4 }}>
                                      <Link to="/Addalloy">
                                        <Button
                                          id="pay-per-task-submit"
                                          type="button"
                                          variant="primary"
                                          className="w-100 mt-2"
                                          style={{
                                            backgroundColor: '#004aad',
                                            borderColor: '#004aad',
                                            marginTop: '10px',
                                          }}
                                        >
                                          Run
                                        </Button>
                                      </Link>
                                    </Col>
                                   </Form.Group>
                </fieldset>
            </Form>
           
        </div>
        </>
    );
};

export default AlloySalesReport;
